





























































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mapState } from 'vuex';
import QuestionMixins from '@/mixins/QuestionMixins';
import QQuestionnaireResultLayout from '@/components/Questionnaire/QQuestionnaireResultLayout.vue';
import { NEGATIVE_RULE_FLAGS } from '@/constants/questionnaire_answer';
import QQuestionAnswer from '@/components/QQuestionAnswer.vue';

@Component({
  components: {
    QQuestionnaireResultLayout,
    QQuestionAnswer,
  },
  computed: {
    ...mapState('CandidateProfile', {
      isUsingForScreens: 'isUsingForScreens',
    }),
    ...mapState({
      loading: 'loading',
    }),
  },
})
export default class BookingReportCandidateProfileQuestions extends Mixins(
  QuestionMixins
) {
  @Prop() readonly report!: any;

  activeIndex = 0;

  negativeRuleFlags = NEGATIVE_RULE_FLAGS;
}
